import store from "../store";
import CandidateFunctions from '@/classes/CandidateFunctions';

export default async ( { next, router } ) => {

    if ( !CandidateFunctions.getCandidateToken() ) {
        if ( store.getters['candidate/getCandidatePin'] )
            await CandidateFunctions.candidateLogout(store.getters['candidate/getCandidatePin']);
        return router.push( { name: 'candidate.login' } ).catch(()=>{});
    }

    if ( !store.getters['candidate/hasActiveTesting'] )
        return router.push( { name: 'auth.success' } ).catch(()=>{});

    if ( !store.getters['candidate/getCurrentTestingId'] )
        await CandidateFunctions.loadTestingCandidate(  ).then( result => {
            return next();
        } ).catch(()=>{ this.snotifyError('errorAskAdmin',null,5000);});


    return next();

}
